import i18next from 'i18next';
import * as Yup from 'yup';

export default Yup.object().shape({
  password: Yup.string().required(i18next.t('common.validation.required')),
});
